import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TitleTextPipe } from '@app/shared/pipes/title-text.pipe';

@Component({
    selector: 'rn-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    standalone: true,
    imports: [NgClass, FormsModule, TitleTextPipe]
})
export class SelectComponent {
  @Input() labelText?: string; // optional label
  @Input() placeholderText?: string; // optional placeholder option with an empty string value
  @Input() clearSelection?: boolean = false; // flag to reset the dropdown
  @Input() name: string;
  @Input() selectedOption: string = '';
  @Input() options: string[] | { value: string; label: string }[];
  @Input() disabled: boolean = false;
  @Output() selectChanged: EventEmitter<Event|string> = new EventEmitter<Event>();

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['clearSelection'] && changes['clearSelection'].currentValue === true) {
      this.resetDropdown();
    }
  }
  
  listenForChange(event): void {
    this.selectedOption = event.target.value;
    this.selectChanged.emit(event);
  }

  resetDropdown(): void {
    this.selectedOption = '';
    this.selectChanged.emit(this.selectedOption);
  }

  clear() {
    this.selectedOption = '';
  }
}
